const SelectTextWidthIcon = () => {
  return (
    <svg width="16" height="16" viewBox="5 18 75 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.7962 42.2031L18.0493 55.5782"
        stroke="currentColor"
        strokeWidth="5.01609"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0494 51.9934V23.3301"
        stroke="currentColor"
        strokeWidth="5.01609"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.048 55.5782L7.29736 42.2031"
        stroke="currentColor"
        strokeWidth="5.01609"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.8568 57.3691C36.8568 58.8532 38.0599 60.0563 39.5439 60.0563C41.028 60.0563 42.2311 58.8532 42.2311 57.3691H36.8568ZM42.2311 21.54C42.2311 20.0559 41.028 18.8528 39.5439 18.8528C38.0599 18.8528 36.8568 20.0559 36.8568 21.54H42.2311ZM72.6859 57.3691C72.6859 58.8532 73.889 60.0563 75.373 60.0563C76.8571 60.0563 78.0602 58.8532 78.0602 57.3691H72.6859ZM78.0602 21.54C78.0602 20.0559 76.8571 18.8528 75.373 18.8528C73.889 18.8528 72.6859 20.0559 72.6859 21.54H78.0602ZM42.2311 57.3691V21.54H36.8568V57.3691H42.2311ZM78.0602 57.3691V21.54H72.6859V57.3691H78.0602Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SelectTextWidthIcon;
